import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';

interface ImageLightboxProps {
  src: string;
  alt: string;
  children: React.ReactNode;
}

// Deixa qualquer conteúdo clicável e abre a imagem em tamanho grande num popup,
// em vez de navegar pra uma aba nova.
export const ImageLightbox: React.FC<ImageLightboxProps> = ({ src, alt, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="block w-full h-full text-left cursor-zoom-in"
        aria-label={`Ampliar: ${alt}`}
      >
        {children}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-5xl w-[90vw] p-2 bg-transparent border-none shadow-none">
          <DialogTitle className="sr-only">{alt}</DialogTitle>
          <DialogDescription className="sr-only">Visualização ampliada da imagem.</DialogDescription>
          <img src={src} alt={alt} className="w-full h-auto rounded-xl shadow-2xl" />
        </DialogContent>
      </Dialog>
    </>
  );
};
